import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=0d4f0654&scoped=true&lang=pug&"
import script from "./summary.vue?vue&type=script&lang=js&"
export * from "./summary.vue?vue&type=script&lang=js&"
import style0 from "./summary.vue?vue&type=style&index=0&id=0d4f0654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4f0654",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/banking/prepayCards?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231207155841%2Fcomponents%2Fproducts%2Fprepay-cards%2Fsummary.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20231207155841/components/widgets/image.vue').default})
